import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography } from '@material-ui/core/';
import logoSefaz from "../../assets/img/logo-sefaz.png";
import FooterCard from '../FooterCard';

const env = window._env_;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  footer: {
    minHeight: 35,
    margin: '10px 10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    minWidth: 'initial',
  },
  right: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  descriptionAddress: {
    paddingRight: '10px',
  },
  descriptionItem: {
    fontSize: 12,
    margin: 0,
    textAlign: 'right',
    lineHeight: 1.3,
  },
  versionFooterText: {
    fontSize: 12,
    margin: 0,
    textAlign: 'right',
    lineHeight: 1.3,
    alignSelf: 'flex-end'
  },
  footerText: {
    fontSize: 10,
    margin: 0,
    textAlign: 'right',
    lineHeight: 1.3,
  },
  logoFacebook: {
    width: 25,
  },
  logoSefaz: {
    width: 95,
  },
  linkFooterSefaz: {
    color: '#FFF',
    textDecoration: 'none',
    transition: 'all .2s',
    "&:hover": {
      transform: "scale(1.05)",
    }    
  }
}));

export default function ButtonAppBar() {
  const classes = useStyles();
  const date = new Date();
  const currentYear = date.getFullYear();
  return (
    <footer>
      <FooterCard />
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar className={classes.footer}>
            <Typography variant="h6" className={classes.versionFooterText}>
            Versão { env?.version }
          </Typography>
            <div className={classes.right}>
              <a target="_blank" rel="noopener noreferrer" href="http://www.sefaz.salvador.ba.gov.br/Home/Atendimento" className={classes.linkFooterSefaz}>
                <div className={classes.descriptionAddress}>
                  <Typography variant="h6" className={classes.descriptionItem}>
                    Posto Central Rua das Vassouras, nº1 - Centro
                  </Typography>
                  <Typography variant="h6" className={classes.descriptionItem}>
                    Horário: Seg à Sex. - 08:00 às 17:00
                  </Typography>
                  <Typography variant="h6" className={classes.footerText}>
                    @{currentYear} - Todos os direitos reservados
                  </Typography>
                </div>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="http://www.sefaz.salvador.ba.gov.br" className={classes.linkFooterSefaz}>
                <div className={classes.descriptionLogo}>
                  <img
                    src={logoSefaz}
                    className={classes.logoSefaz}
                    alt="Logo Sefaz"
                  />
                </div>
              </a>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    </footer>
  );
}